import Link from "next/link";
import Image from "next/image";
import { Badge } from "@/components/ui/badge";

interface ProjectCardProps {
  id: string;
  title: string;
  description: string;
  kpi: string[];
  featuredKpi: string;
  stack: string[];
  link: string;
  year?: number;
  story?: string;
}

const ProjectCard = ({ id, title, description, featuredKpi, stack }: ProjectCardProps) => {
  return (
    <Link 
      href={`/projects/${id}`}
      className="group block"
      data-project-id={id}
    >
      <div className="relative rounded-lg overflow-hidden border border-border/50 hover:border-border transition-colors duration-300 hover:bg-muted/5 hover:shadow-lg">
        <div className="flex flex-col md:flex-row md:items-stretch">
          <div className="hidden md:block w-[50%] relative h-[200px] overflow-hidden image-container">
            <div className="absolute inset-0 bg-gradient-to-l from-background via-background/75 via-50% to-transparent z-10" />
            <Image 
              src={`/projectScreens/${id}.png`}
              alt={`${title} screenshot`}
              fill
              className="object-cover object-top"
              loading="lazy"
              sizes="(max-width: 768px) 100vw, 50vw"
              onError={() => {
                const fallback = document.createElement('div');
                fallback.className = 'absolute inset-0 flex items-center justify-center bg-muted';
                const text = document.createElement('span');
                text.className = 'text-4xl font-bold text-primary/30';
                text.textContent = title.charAt(0);
                fallback.appendChild(text);
                const container = document.querySelector(`[data-project-id="${id}"] .image-container`);
                if (container) {
                  container.innerHTML = '';
                  container.appendChild(fallback);
                }
              }}
            />
          </div>
          <div className="flex-1 relative z-20 md:-ml-[20%] p-6 flex items-center">
            <div className="space-y-4">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2">
                <div>
                  <h3 className="text-2xl font-bold text-primary">
                    {title}
                    {/* {link ? (
                      <a 
                        href={link} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        className="hover:underline"
                      >
                        {title}
                      </a>
                    ) : (
                      title
                    )} */}
                  </h3>
                </div>
                <Badge variant="outline" className="bg-accent/10 text-accent border-0 w-fit">
                  {featuredKpi}
                </Badge>
              </div>
              
              <p className="text-muted-foreground leading-relaxed">
                {description}
              </p>
              
              <div className="flex flex-wrap gap-2">
                {stack.map((tech, idx) => (
                  <Badge 
                    key={idx} 
                    variant="secondary" 
                    className="text-xs font-medium"
                  >
                    {tech}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;
